import React from 'react';
import 'twin.macro';
import { StaticImage } from 'gatsby-plugin-image';

import CardLink, { cardLinkImageStyles } from '~components/Card/CardLink';

const StemCellTherapiesCard: React.FC = () => (
  <CardLink to="/accelerating-research/stem-cell-therapies" variant="blue" title="FRDJ et l’IRSC annoncent des nouvelles subventions pour accélérer les thérapies à base de cellules souches pour le diabète de type 1">
    <StaticImage src="../../images/winnders.jpg" alt="" style={cardLinkImageStyles} />
  </CardLink>
);

export default StemCellTherapiesCard;
